import { api } from "../base";
import type {
  ITradingSessionState,
  ITradingSessionStateRequest,
  ITradingSessionStateList,
} from "@pulse-ui/codegen-v2/generated_ts/trading_session_state";

export type {
  ITradingSessionState,
  ITradingSessionStateRequest,
  ITradingSessionStateList,
} from "@pulse-ui/codegen-v2/generated_ts/trading_session_state";
export { TradingSessionStateScope } from "@pulse-ui/codegen-v2/generated_ts/trading_session_state";

const tradingSessionStateEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getTradingSessionState: build.query<ITradingSessionStateList, void>({
      query: () => ({ url: "/api/trading-ops/v1/trading-session-state" }),
      providesTags: ["TradingSessionState"],
    }),
    setTradingSessionState: build.mutation<ITradingSessionState, ITradingSessionStateRequest>({
      query: (body) => ({
        url: "/api/trading-ops/v1/trading-session-state",
        method: "PUT",
        body,
      }),
      // The PUT response is authoritative; patch the cached list from it instead of
      // refetching, which would race topic->read-model propagation and read stale.
      async onQueryStarted(_body, { dispatch, queryFulfilled }) {
        try {
          const { data: updated } = await queryFulfilled;
          dispatch(
            tradingSessionStateEndpoints.util.updateQueryData(
              "getTradingSessionState",
              undefined,
              (draft) => {
                const i = draft.states.findIndex(
                  (s) =>
                    s.scope === updated.scope &&
                    (s.session_id ?? null) === (updated.session_id ?? null),
                );
                if (updated.halted) {
                  if (i >= 0) draft.states[i] = updated;
                  else draft.states.push(updated);
                } else if (i >= 0) {
                  draft.states.splice(i, 1);
                }
              },
            ),
          );
        } catch {
          // PUT failed; the mutation's error state drives the UI.
        }
      },
    }),
  }),
});

export const { useGetTradingSessionStateQuery, useSetTradingSessionStateMutation } =
  tradingSessionStateEndpoints;
